import { Component, Input } from '@angular/core';
import { RadioButtonItem } from '../../../../index';

@Component({
  templateUrl: './tool-tip.html'  
})
export class TooltipComponent { 

    constructor() {
      this.DefaultItems = 
      [
        new RadioButtonItem(true, "Short Text", "Tooltip"),
        new RadioButtonItem(false, "Longer Text", "A longer tooltip"),
        new RadioButtonItem(false, "Very long text", this.TooltipContent),
      ];
    }

    public showTooltip: boolean;
    public Tooltip: string = "Button tooltip"
    public TooltipContent = "Contented get distrusts certainty nay are frankness concealed ham. On unaffected resolution on considered of. No thought me husband or colonel forming effects. End sitting shewing who saw besides son musical adapted. Contrasted interested eat alteration pianoforte sympathize was. He families believed if no elegance interest surprise an. It abode wrong miles an so delay plate. She relation own put outlived may disposed.";

    private defaultGroup: any = "Tooltip";
    @Input('DefaultGroup')
    get DefaultGroup(): any {        
        return this.defaultGroup;
    }
  
    @Input() DefaultItems: Array<RadioButtonItem>;
    set DefaultGroup(value: any) {
        this.defaultGroup = value;

        for (var i=0; i<this.DefaultItems.length; i++) {
            var item = this.DefaultItems[i];
            item.IsChecked = this.defaultGroup == item.Value;
        }
    } 
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/tool-tip/tool-tip-component.ts